<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm03_title"><a id="page_iii"></a><strong><span class="small">BROWN BOYS AND RICE QUEENS</span></strong></h1>
<p class="subtitle"><em>Spellbinding Performance in the Asias</em></p>
<p class="author">Eng-Beng Lim</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?5b504232